import { Typography } from "@packages/ds";
import styled from "styled-components";

export const Info = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  code {
    font-weight: normal;
  }
  margin-bottom: 32px;
`;

export const SettingsTitle = styled(Typography.Title)`
  margin-bottom: 16px;
`;
